/* ==========================================================================
   Mikai Club · Landing Kit Bienestar — selector de pack/acabado, sincronía
   entre módulos, barra fija móvil y desplazamiento al módulo de compra.

   Sin analítica propia (Shopify Web Pixels ya emite los eventos). El carrito lo
   resuelve <product-form> del tema. Conserva UTM, gclid y fbclid en la URL.
   packIndex = -1 → el producto no tiene opción de pack (solo acabado).
   ========================================================================== */
(function () {
  'use strict';
  if (window.MKLanding) return;
  window.MKLanding = { version: '1.1.0' };

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var dataEl = document.querySelector('script[data-mkl-product]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { console.error('[MKLanding] JSON de producto inválido', e); return; }

    var variants = data.variants || [];
    var P = typeof data.packIndex === 'number' ? data.packIndex : 0;
    var hasPack = P >= 0;
    var F = typeof data.finishIndex === 'number' ? data.finishIndex : 1;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var fmt;
    try {
      var cur = data.currency || 'CLP';
      var zeroDecimals = ['CLP', 'JPY', 'KRW', 'PYG', 'VND', 'ISK', 'UGX'].indexOf(cur) > -1;
      fmt = new Intl.NumberFormat('es-CL', { style: 'currency', currency: cur, minimumFractionDigits: zeroDecimals ? 0 : 2, maximumFractionDigits: zeroDecimals ? 0 : 2 });
    } catch (e) { fmt = { format: function (n) { return '$' + Math.round(n).toLocaleString('es-CL'); } }; }
    function money(cents) { return fmt.format(cents / 100).replace(/\s/g, ''); }
    function monthsOf(pack) { var n = parseInt(String(pack), 10); return n > 0 ? n : 1; }
    function perMonth(cents, pack) { return Math.round(cents / 100 / monthsOf(pack)) * 100; }

    function findVariant(pack, finish) {
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options;
        if ((!hasPack || o[P] === pack) && (o.length <= F || o[F] === finish)) return variants[i];
      }
      return null;
    }
    function byId(id) {
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
      return null;
    }
    function anyForPack(pack) {
      for (var i = 0; i < variants.length; i++) if (!hasPack || variants[i].options[P] === pack) return variants[i];
      return null;
    }

    /* ---------- Estado inicial ---------- */
    var urlVariant = null;
    try { urlVariant = new URL(window.location.href).searchParams.get('variant'); } catch (e) {}
    var offerEl = document.querySelector('[data-mkl-offer]');
    var initial = (urlVariant && byId(urlVariant)) ||
      (offerEl && byId(offerEl.getAttribute('data-mkl-default-variant'))) ||
      byId(data.defaultVariant) || variants[0];
    if (!initial) return;

    var state = { pack: hasPack ? initial.options[P] : '', finish: initial.options[F] };
    var lastVariantId = null;

    /* ---------- Render ---------- */
    function each(sel, fn) { Array.prototype.forEach.call(document.querySelectorAll(sel), fn); }
    function cssEsc(v) { return window.CSS && CSS.escape ? CSS.escape(v) : String(v).replace(/"/g, '\\"'); }

    function render(opts) {
      opts = opts || {};
      var v = findVariant(state.pack, state.finish);
      var available = !!(v && v.available);

      // Radios (todos los módulos)
      each('input[data-mkl-pack]', function (el) { el.checked = el.value === state.pack; });
      each('input[data-mkl-finish]', function (el) { el.checked = el.value === state.finish; });
      each('[data-mkl-finish-label]', function (el) { el.textContent = state.finish; });

      // Precio por pack según el acabado elegido
      each('[data-mkl-pack-price]', function (el) {
        var pack = el.getAttribute('data-mkl-pack-price');
        var pv = findVariant(pack, state.finish) || anyForPack(pack);
        if (pv) el.textContent = money(pv.price);
      });
      each('[data-mkl-pack-month]', function (el) {
        var pack = el.getAttribute('data-mkl-pack-month');
        var pv = findVariant(pack, state.finish) || anyForPack(pack);
        if (pv) el.textContent = money(perMonth(pv.price, pack));
      });
      each('[data-mkl-pack-compare]', function (el) {
        var pack = el.getAttribute('data-mkl-pack-compare');
        var pv = findVariant(pack, state.finish) || anyForPack(pack);
        var show = pv && pv.compare_at_price > pv.price;
        el.hidden = !show;
        if (show) el.textContent = money(pv.compare_at_price);
      });

      // Disponibilidad por combinación
      each('[data-mkl-pack-wrap]', function (el) {
        var pv = findVariant(el.getAttribute('data-mkl-pack-wrap'), state.finish);
        el.classList.toggle('is-unavailable', !(pv && pv.available));
      });
      each('[data-mkl-finish-wrap]', function (el) {
        var fv = findVariant(state.pack, el.getAttribute('data-mkl-finish-wrap'));
        el.classList.toggle('is-unavailable', !(fv && fv.available));
      });

      // Resumen de la variante seleccionada
      var title = [state.pack, state.finish].filter(Boolean).join(' · ');
      each('[data-mkl-title]', function (el) { el.textContent = title; });
      each('[data-mkl-price]', function (el) { el.textContent = v ? money(v.price) : '—'; });
      each('[data-mkl-compare]', function (el) {
        var show = v && v.compare_at_price > v.price;
        el.hidden = !show;
        if (show) el.textContent = money(v.compare_at_price);
      });
      each('[data-mkl-month]', function (el) {
        var m = monthsOf(state.pack);
        el.hidden = !v || m < 2;
        var val = el.querySelector('[data-mkl-month-value]');
        if (v && val) val.textContent = money(perMonth(v.price, state.pack));
      });
      each('[data-mkl-stock]', function (el) {
        var inT = el.getAttribute('data-in') || 'Disponible';
        var outT = el.getAttribute('data-out') || 'Agotado';
        el.textContent = available ? inT : (v ? outT : 'No disponible');
        el.classList.toggle('is-out', !available);
      });

      // Formularios: ID de variante real + estado del botón
      each('form[data-mkl-form]', function (form) {
        var input = form.querySelector('input[name="id"]');
        if (input && v) { input.value = v.id; input.disabled = false; }
        var btn = form.querySelector('[data-mkl-submit]');
        if (btn) {
          if (!btn.dataset.label) {
            var t = btn.querySelector('[data-addtocart-text]');
            btn.dataset.label = available ? (t ? t.textContent.trim() : 'Añadir al carrito') : 'Añadir al carrito';
          }
          var label = btn.querySelector('[data-addtocart-text]');
          if (available) { btn.removeAttribute('disabled'); btn.removeAttribute('aria-disabled'); }
          else { btn.setAttribute('disabled', 'disabled'); }
          if (label) label.textContent = available ? btn.dataset.label : (v ? 'Agotado' : 'No disponible');
        }
        // Si hubo un error previo, el componente del tema deja el botón bloqueado: lo liberamos al cambiar de variante.
        var pf = form.closest('product-form');
        if (pf && v && lastVariantId && lastVariantId !== v.id) {
          pf.error = false;
          if (typeof pf.handleErrorMessage === 'function') pf.handleErrorMessage();
        }
        var payWrap = form.querySelector('.shopify-payment-button');
        if (payWrap) payWrap.style.display = available ? '' : 'none';
      });
      each('[data-mkl-add]', function (b) {
        if (available) b.removeAttribute('disabled'); else b.setAttribute('disabled', 'disabled');
      });

      // Imagen de la variante (opcional)
      var hero = document.querySelector('[data-mkl-hero]');
      if (opts.userAction && v && v.media_id && hero && hero.getAttribute('data-mkl-follow-image') === 'true') {
        var slide = hero.querySelector('[data-media-id="' + cssEsc(String(v.media_id)) + '"]');
        var track = hero.querySelector('[data-mkl-track]');
        if (slide && track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      // URL: actualiza ?variant= conservando UTM y demás parámetros, sin crear historial
      // (también al cargar sin ?variant=, para que widgets como el de cuotas lean la variante preseleccionada)
      if ((opts.userAction || opts.syncUrl) && v && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', u.toString());
        } catch (e) {}
      }

      lastVariantId = v ? v.id : null;
      hideStatus();
    }

    /* ---------- Eventos de selección ---------- */
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches('input[data-mkl-pack]')) { state.pack = t.value; render({ userAction: true }); }
      else if (t.matches('input[data-mkl-finish]')) { state.finish = t.value; render({ userAction: true }); }
    });

    /* ---------- Desplazamiento al módulo de compra ---------- */
    function goToBuy(e) {
      var target = document.getElementById('mk-comprar');
      if (!target) return;
      if (e) e.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      setTimeout(function () {
        // Respaldo: si el navegador no completó el desplazamiento suave, salta directo.
        var top = target.getBoundingClientRect().top;
        if (top > 200 || top < -200) target.scrollIntoView({ behavior: 'auto', block: 'start' });
        var checked = target.querySelector('input[data-mkl-pack]:checked') || target.querySelector('input[data-mkl-pack]') || target.querySelector('input[data-mkl-finish]:checked');
        if (checked) { try { checked.focus({ preventScroll: true }); } catch (x) { checked.focus(); } }
      }, reduceMotion ? 0 : 900);
    }
    document.addEventListener('click', function (e) {
      var s = e.target.closest && e.target.closest('[data-mkl-scroll]');
      if (s) { goToBuy(e); return; }
      var a = e.target.closest && e.target.closest('[data-mkl-add]');
      if (a) {
        e.preventDefault();
        var form = document.querySelector('form[data-mkl-form]');
        var btn = form && form.querySelector('[data-mkl-submit]');
        if (!form || !btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') { goToBuy(); return; }
        if (typeof form.requestSubmit === 'function') form.requestSubmit(btn); else btn.click();
      }
    });

    /* ---------- Confirmación visual al añadir ---------- */
    var statusTimer;
    function hideStatus() { each('[data-mkl-status]', function (el) { el.hidden = true; }); }
    if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      window.subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        if (!evt || evt.source !== 'product-form') return;
        var form = document.querySelector('form[data-mkl-form]');
        var input = form && form.querySelector('input[name="id"]');
        if (input && String(evt.productVariantId) !== String(input.value)) return;
        each('[data-mkl-status]', function (el) { el.hidden = false; });
        clearTimeout(statusTimer);
        statusTimer = setTimeout(hideStatus, 6000);
      });
    }

    /* ---------- Galería del hero (scroll-snap + puntos) ---------- */
    var track = document.querySelector('[data-mkl-track]');
    var dotsWrap = document.querySelector('[data-mkl-dots]');
    if (track && dotsWrap) {
      var slides = track.children;
      if (slides.length > 1) {
        for (var i = 0; i < slides.length; i++) {
          (function (idx) {
            var d = document.createElement('button');
            d.type = 'button';
            d.className = 'mkl-hero__dot';
            d.setAttribute('aria-label', 'Ver imagen ' + (idx + 1) + ' de ' + slides.length);
            if (idx === 0) d.setAttribute('aria-current', 'true');
            d.addEventListener('click', function () {
              track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
            });
            dotsWrap.appendChild(d);
          })(i);
        }
        var prev = document.querySelector('[data-mkl-prev]');
        var next = document.querySelector('[data-mkl-next]');
        var current = function () { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); };
        var goTo = function (idx) {
          idx = Math.max(0, Math.min(slides.length - 1, idx));
          track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        };
        if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
        if (next) next.addEventListener('click', function () { goTo(current() + 1); });
        var raf;
        track.addEventListener('scroll', function () {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            var idx = current();
            Array.prototype.forEach.call(dotsWrap.children, function (d, j) {
              if (j === idx) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
            });
            if (prev) prev.disabled = idx <= 0;
            if (next) next.disabled = idx >= slides.length - 1;
          });
        }, { passive: true });
      }
    }

    /* ---------- Barra fija móvil ---------- */
    var sticky = document.querySelector('[data-mkl-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      var watched = [document.querySelector('[data-mkl-hero-cta]'), document.querySelector('[data-mkl-buy]'), document.querySelector('.mkl-offer__cards')].filter(Boolean);
      var visible = new Map();
      var heroEl = document.querySelector('[data-mkl-hero]');
      var update = function () {
        var anyVisible = false;
        visible.forEach(function (v) { if (v) anyVisible = true; });
        var pastHero = heroEl ? heroEl.getBoundingClientRect().bottom < 0 : window.scrollY > 400;
        var show = !anyVisible && pastHero;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        each('[data-mkl-sticky] a, [data-mkl-sticky] button', function (b) { b.tabIndex = show ? 0 : -1; });
        document.body.classList.toggle('mkl-sticky-on', show && window.matchMedia('(max-width: 899px)').matches);
      };
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { visible.set(en.target, en.isIntersecting); });
        update();
      }, { threshold: 0 });
      watched.forEach(function (el) { visible.set(el, false); io.observe(el); });
      window.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    }

    render({ syncUrl: !urlVariant });
  });
})();